import { DumbLiaison } from "../../../member-admin/membership-management/DTOs/dumb-liaison";
import { DumbPublicMemberLocation } from "./dumb-public-member-location";

export class DumbPublicMember {
    companyId: string;
    memberName: string;
    memberDescription: string;
    canRequestIntro: boolean;
    liaison: DumbLiaison;
    locations: DumbPublicMemberLocation[];
    logoUrl: string;
    canSeeLiaison: boolean;
    website: string;
}
